import {FunctionalModal} from "./FunctionalModal";
import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {BaseModal} from "./modalStyle";
import ExitButton from "../buttons/ExitButton";
import SendFormButton from "../buttons/SendFormButton";
import {useDispatch, useSelector} from "react-redux";
import {CLEAR_LINK, getLink, patchLink, postLinks} from "../link/linksActions";
import {loadProject} from "../project/one-project/projectAction";
import {Formik, ErrorMessage} from 'formik';
import * as Yup from "yup";
import {FormFormik, InputTextFormik} from "../inputs/InputStyle";
import Loader from "../progress-bar/Loader";

const AddOrEditLinkModal = ({setIsOpen, id}) => {
    const {id: currentUserId} = useSelector(state => state.currentUser)
    const {id: projectId} = useSelector(state => state.project)
    const {isLoading, name, url} = useSelector(state => state.link)
    const dispatch = useDispatch()
    const [data, setData] = useState({name: "", url: "", authorId: currentUserId, projectId: projectId})


    useEffect(() => {
        dispatch(getLink(id))
        return () => {
            dispatch({type: CLEAR_LINK})
        }
    }, [dispatch, id])

    useEffect(() => {
        if (id) {
            setData(state => ({
                ...state,
                name: name,
                url: url
            }))
        }
    }, [id, name, url])

    const close = () => {
        setIsOpen(false)
    }

    const validateSchema = Yup.object({
        name: Yup
            .string()
            .min(1, "Ce nom est trop court")
            .required('Veuillez écrire un libellé'),
        url: Yup
            .string()
            .min(5, "Ce lien est trop court")
            .required('Veuillez indiquer un lien')
    })

    const handleSubmit = async (data) => {
        if (id === 0) {
            await dispatch(postLinks(data))
        } else {
            await dispatch(patchLink(id, data))
        }
        await dispatch(loadProject(projectId))
        setIsOpen(false)
    }

    const component = () => {
        return (
            <Modal>
                {id !== 0 && isLoading ? <Loader/> :
                    <>
                        <FirstSection>
                            <h1> {id === 0 ? "Ajouter un lien" : "Modifier un lien"}</h1>
                            <ExitButton
                                closeUpdate={close}/>
                        </FirstSection>
                        <Formik
                            enableReinitialize
                            initialValues={{
                                name: data.name,
                                url: data.url,
                                authorId: currentUserId,
                                projectId: projectId
                            }}
                            validationSchema={validateSchema}
                            onSubmit={handleSubmit}>
                            {({dirty, isValid}) => (
                                <Form noValidate>
                                    <InputTextFormik name={"name"}
                                           type={"text"}
                                           placeholder={"Écrivez le libellé ici"}
                                    />
                                    <p className={"error-text"}><ErrorMessage name="name"/></p>
                                    <InputTextFormik name={"url"}
                                           type={"url"}
                                           placeholder={"Placez l'url ici"}
                                    />
                                    <p className={"error-text"}><ErrorMessage name="url"/></p>
                                    <SendFormButton state={(isValid && dirty)} actionName={'Ajouter'}/>
                                </Form>
                            )}
                        </Formik>
                    </>
                }

            </Modal>
        )
    }
    return (
        <FunctionalModal component={component()} setOpen={setIsOpen}/>
    )
}

const Form = styled(FormFormik)``

const Modal = styled(BaseModal)`
  width: 100%;
  height: 100%;
  margin: auto;
  padding: 1rem;
  @media (min-width: 900px) {
    width: 850px;
    height: fit-content;
  }
`

const FirstSection = styled.div`
  display: flex;
  gap: 1rem;

  h1 {
    flex-grow: 1;
  }
`
export default AddOrEditLinkModal